import React, { useState } from 'react';
import { faSparkles } from '@fortawesome/pro-solid-svg-icons';
import { faSparkles as faSparklesRegular } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, ListGroup, OverlayTrigger, Popover } from 'react-bootstrap-5';
import { faLink } from '@fortawesome/pro-solid-svg-icons';

export default function AiBadge({ sources, verified }: { sources: string[], verified: boolean }) {
  const [showPopover, setShowPopover] = useState(false);
  const [popoverHover, setPopoverHover] = useState(false);

  const popover = (
    <Popover
      id="ai-popover"
      style={{ minWidth: 300 }}
      onMouseEnter={() => setPopoverHover(true)}
      onMouseLeave={() => setPopoverHover(false)}
    >
      <Popover.Header as="h5" className="fw-bolder">
        <FontAwesomeIcon className="me-2 icon-gradient" icon={faSparklesRegular} />
        AI {verified ? 'Verified' : 'Sourced'}
      </Popover.Header>
      <Popover.Body>
        <p>
          AI research found this contact in various public records and other sources{sources.length == 0 ? '.' : ':'}
        </p>
        {sources.length > 0 && (
          <ListGroup>
            {sources.map(source => (
              <ListGroup.Item
                action
                className="text-primary text-truncate d-flex flex-grow-1"
                href={source}
                key={source}
                target="_blank"
                onClick={e => e.stopPropagation()}
              >
                <FontAwesomeIcon className="me-2" icon={faLink} />
                {source}
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger
      container={document.body}
      overlay={popover}
      placement="auto"
      show={showPopover || popoverHover}
      onToggle={() => setShowPopover(!showPopover)}
    >
      <Badge bg="" className="badge-gradient badge-sm py-0-5">
        <FontAwesomeIcon icon={faSparkles} size="xs"/>
        <span className="fs-x-small">AI {verified ? 'Verified' : 'Sourced'}</span>
      </Badge>
    </OverlayTrigger>
  );
}
